module.exports = __webpack_public_path__ + "static/img/call_2x.343f792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/call_2x.png
// module id = EH6A
// module chunks = 1